module.exports = __webpack_public_path__ + "img/img1.9798b8fa.png";